// extracted by mini-css-extract-plugin
export default {"container":"AboutTeam_container__wF4rZ","leader":"AboutTeam_leader__N8PJo","text-appear":"AboutTeam_text-appear__IjW5j","card":"AboutTeam_card__u2jGu","item":"AboutTeam_item__e7-iC"};